import StarSolidIcon from '@8x8/oxygen-icon/icons/StarSolidIcon';
import translate from '~/services/translate/translate';

let freeFeatures;
let proFeatures;

export const setupFeatures = () => {
  freeFeatures = {
    title: translate('meet_jit_si'),
    description: translate('meetings_free_description'),
    features: [{
      text: translate('meetings_table_free_feature_1'),
    }],
  };
  proFeatures = {
    title: translate('meetings_pro'),
    description: translate('meetings_pro_description'),
    backgroundColor: 'rgba(255, 255, 255, 0.15)',
    Icon: StarSolidIcon,
    features: [{
      text: translate('meetings_for_free_feature_2_regular'),
      boldText: translate('meetings_for_free_feature_2_bold'),
    }, {
      text: translate('meetings_for_free_feature_3_regular'),
      boldText: translate('meetings_for_free_feature_3_bold'),
    }, {
      text: translate('meetings_for_free_feature_4_regular'),
      boldText: translate('meetings_for_free_feature_4_bold'),
    }, {
      text: translate('meetings_for_free_feature_5_regular'),
      boldText: translate('meetings_for_free_feature_5_bold'),
    }, {
      text: translate('meetings_for_free_feature_6_regular'),
      boldText: translate('meetings_for_free_feature_6_bold'),
    },
    ],
  }
}

export const getFreeFeatures = () => freeFeatures;

export const getProFeatures = () => proFeatures;
